import groupings from './groupings';

export default {
  mixins: [groupings],
  methods: {
    flashcardsBySection(categoryId) {
      if (!categoryId) return [];
      const flashcardList = this.$store.getters['flashcards/flashcardList'].filter(f => f);
      const filtered = flashcardList
        .filter( f => f.categoryIds.includes(categoryId))
        .sort(this.flashcardSortComparator);
      return filtered;
    },
    flashcardStateComparator(stateA, stateB) {
      const flashcards = this.$store.getters['flashcards/flashcards'];
      const flashcardA = flashcards[stateA.flashcardId];
      const flashcardB = flashcards[stateB.flashcardId];
      return this.flashcardSortComparator(flashcardA, flashcardB);
    },
    flashcardSortComparator(flashcardA, flashcardB) {
      const pseudoRand = (num) => (num * Math.PI * 1000) % 2000;

      const groupAId = this.getGroupingId(flashcardA.id);
      const groupBId = this.getGroupingId(flashcardB.id);

      // if the flashcard is not in a group, we want to use the flashcard id
      // as the pseudo-random so that they are interleaved between flashcards with groups
      // otherwise they will all clump together
      const groupAOrder = pseudoRand(groupAId || flashcardA.id);
      const groupBOrder = pseudoRand(groupBId || flashcardB.id);

      // if the flashcards are in the same group, we want to sort them by their
      // order in the group
      let flashcardAOrder = 0, flashcardBOrder = 0;
      {
        if (groupAId) {
          const groupA = this.$store.getters['groupings/all'][groupAId];
          flashcardAOrder = groupA.assetAssociations.find( aa => aa.assetBId === flashcardA.id )?.order || 0;
        }

        if (groupBId) {
          const groupB = this.$store.getters['groupings/all'][groupBId];
          flashcardBOrder = groupB.assetAssociations.find( aa => aa.assetBId === flashcardB.id )?.order || 0;
        }
      }

      return groupAOrder - groupBOrder || flashcardAOrder - flashcardBOrder;
    },
  },
};
